import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import Pulse from "../Loader/Pulse";
import ServerRequest from "../../exports/ServerRequest";
import useTheme from "../../hooks/useTheme";

function ReportViewer({ html }) {
  const { theme } = useTheme();
  const vars =
    theme === "dark"
      ? {
          "--r-bg": "var(--white)",
          "--r-bg-alt": "#191e24",
          "--r-bg-subtle": "#15191e",
          "--r-text": "#ecf9ff",
          "--r-text-subtle": "#9ca3af",
          "--r-border": "#3f3f46",
        }
      : {
          "--r-bg": "var(--white)",
          "--r-bg-alt": "#eeeeee",
          "--r-bg-subtle": "#ffffff",
          "--r-text": "#011627",
          "--r-text-subtle": "#6b7280",
          "--r-border": "#e5e7eb",
        };

  return (
    <div
      style={{
        height: "100vh",
        overflowY: "auto",
        backgroundColor: "var(--white)",
      }}
    >
      <div
        style={{
          ...vars,
          padding: "20px",
          maxWidth: "1200px",
          margin: "0 auto",
          backgroundColor: "var(--white)"
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}

const PublicAIReport = () => {
  const { code } = useParams();

  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchReport();
  }, [code]);

  const fetchReport = async () => {
    try {
      setLoading(true);
      const res = await ServerRequest({
        url: `/report/${code}`,
        method: "GET",
      });

      const report = res.data;

      if (!report?.output_url) {
        setError(true);
        return;
      }

      const htmlRes = await fetch(report.output_url);
      const raw = await htmlRes.text();

      const clean = DOMPurify.sanitize(raw, {
        USE_PROFILES: { html: true },
      });

      setHtml(clean);
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          flex: "1",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Pulse />
      </div>
    );

  if (error) {
    return (
      <div className="p-6">
        <h2>Report not found</h2>
      </div>
    );
  }

  return <ReportViewer html={html} />;
};

export default PublicAIReport;
